<script>
import Dialog from "primevue/dialog";
import {mapActions, mapState} from "pinia";
import {editProposalStore} from "@/store/editProposalStore";
export default {
  name: "ProposalCantSavingModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(editProposalStore, [
      'proposalCantSavingModalState'
    ]),
    modalState: {
      get() {
        return this.proposalCantSavingModalState;
      },
      set() {
        this.toggleProposalCantSavingModalState();
      },
    },
  },
  methods: {
  ...mapActions(editProposalStore, [
      "toggleProposalCantSavingModalState"
    ]),
    closeModal() {
      this.toggleProposalCantSavingModalState();
    },
    reloadPage() {
      window.location.reload();
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          :header="$t('proposalCantSavingModal.title')"
          class="proposal-cant-saving-modal"
          modal
  >
    <div>
      <p>{{ $t('proposalCantSavingModal.p1') }}</p>
      <p>{{ $t('proposalCantSavingModal.p2') }}</p>
      <p>
        {{ $t('proposalCantSavingModal.p3') }}
        <a href="mailto:bugs@peoplepolitics.com">bugs@peoplepolitics.com</a>
      </p>
    </div>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="closeModal()">
        {{$t('common.buttons.close')}}
      </button>
      <button class="p-dialog-primary-btn" @click="reloadPage()">
        {{$t('common.buttons.refreshPage')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.proposal-cant-saving-modal {
  .p-dialog-content {
    padding: 15px;
    p {
      margin-bottom: 7px;
    }
  }
}
</style>